import React, { useContext } from 'react';
import RadioButton from '../components/radio-button';
import RadioButtonGroupContext from '../context';
const RadioButtonContainer = ({
  inputRef = null,
  disabled = false,
  id,
  label,
  tooltipProps = undefined,
  value,
  isLabelBold = false,
}) => {
  const { defaultSelectedValue, name, onChange, selectedValue } =
    useContext(RadioButtonGroupContext);
  const isChecked = selectedValue === undefined ? undefined : selectedValue === value;
  const isDefaultChecked =
    defaultSelectedValue === undefined ? undefined : defaultSelectedValue === value;

  return (
    <RadioButton
      inputRef={inputRef}
      checked={isChecked}
      defaultChecked={isDefaultChecked}
      disabled={disabled}
      id={id}
      label={label}
      name={name}
      onChange={onChange}
      tooltipProps={tooltipProps}
      value={value}
      isLabelBold={isLabelBold}
    />
  );
};

export default RadioButtonContainer;
